export const SportEventType = {
  Destroy: 1,
  ThemeChange: 2,
  RouteChange: 3,
  EventDetails: 4,
  InsufficientAmount:5,
  BalanceUpdate: 6

}

export const SportDispatchingEventType = {
  Destroy: 1,
  ThemeChange: 2,
  RouteChange: 3,
  OpenBetSlip: 4,
  UpdateFreeBet: 5
}

export default SportEventType;